import { Box, Text } from '@chakra-ui/react'

export const DataDisplay: React.FC<{
  label?: string
  name?: string | number
}> = ({ label, name }) => {
  return (
    <Box>
      <Text
        mb="8px"
        fontSize="13px"
        lineHeight={1}
        fontWeight={500}
        color="gray.600"
      >
        {label}
      </Text>
      <Text fontSize="18px" lineHeight={1} fontWeight={700}>
        {name}
      </Text>
    </Box>
  )
}
